import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import React from 'react';
import { useLang } from '../../util/lang';

const BasePaperProps = {
    style: {
        borderRadius: 12,
        backgroundColor: '#ecebee',
        padding: 6,
        minWidth: 1080,
    },
};

const BaseCloseBtnStyle = {
    color: '#7b7c7f',
    borderColor: '#7b7c7f',
};

const BaseContentStyle = {
    padding: '24px 24px 0 24px',
    overflowY: 'visible',
};

const BaseActionStyle = {
    padding: '24px 24px 10px',
};

export default function ColorTitleDialog({
    open,
    handleClose,
    title = '',
    children,
    paperProps,
    showCloseBtn = false,
    closeBtnStyle,
    actionStyle,
    contentStyle,
}) {
    const getLang = useLang();
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            BackdropProps={{
                style: { backgroundColor: '#939598', opacity: 0.7 },
            }}
            PaperProps={{
                ...BasePaperProps,
                ...paperProps,
            }}
        >
            <DialogTitle
                style={{
                    backgroundColor: '#542a77',
                    color: 'white',
                    borderTopRightRadius: 10,
                    borderTopLeftRadius: 10,
                }}
            >
                {title}
            </DialogTitle>
            <DialogContent style={{ ...BaseContentStyle, ...contentStyle }}>{children ? children : null}</DialogContent>
            <DialogActions style={{ ...BaseActionStyle, ...actionStyle }}>
                {showCloseBtn && (
                    <Button
                        style={{
                            ...BaseCloseBtnStyle,
                            ...closeBtnStyle,
                        }}
                        variant="outlined"
                        onClick={handleClose}
                    >
                        {getLang('@global.const.close')}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}
